import React, { useEffect, useState } from "react";
import {
  PackableStorageClientContext,
  PackableStorageClientContextProps,
} from "./PackableStorageClientContext.types";
import {
  ShippingCart,
  ShippingCartEntity,
} from "../shippingcart/ShippingCart.types";

export const PackableStorageClientContextProvider: React.FC<
  PackableStorageClientContextProps
> = ({ children }) => {
  const [searchString, setSearchString] = useState<string>("");
  const [shippingCart, setShippingCart] = useState<ShippingCart>(
    new ShippingCartEntity()
  );

  const onSearchStringUpdate = (searchString: string): void => {
    setSearchString(searchString);
  };

  const onShippingCartUpdate = (shippingCart: ShippingCart): void => {
    setShippingCart(shippingCart);
    sessionStorage.setItem("shippingCart", JSON.stringify(shippingCart));
  };

  useEffect(() => {
    let shippingCart: ShippingCart | undefined = undefined;
    let shippingCartString = sessionStorage.shippingCart;
    if (!shippingCartString || shippingCartString === undefined) {
      shippingCart = new ShippingCartEntity();
    } else {
      shippingCart = JSON.parse(shippingCartString);
    }
    if (shippingCart) {
      setShippingCart(shippingCart);
    }
  }, []);

  return (
    <PackableStorageClientContext.Provider
      value={{
        searchString,
        onSearchStringUpdate,
        shippingCart,
        onShippingCartUpdate,
      }}
    >
      {children}
    </PackableStorageClientContext.Provider>
  );
};
